import http from "../../http";
import { useMutation } from "../../../contexts/HttpQueryContext";
import { useUser } from "../../../contexts/UserContext";
import { SESSION_KEY_NOTIFICATIONS_BANNER_DISMISSED } from "../../../constants/constants";

export function useValidateToken({ options = {} } = {}) {
  return useMutation({
    ...options,
    mutationFn: ({ token }) => {
      const url = http.url("auth.signing.validateToken");
      return http.api.post(url, { token: token });
    },
  });
}

export function useSignIn({ options = {} } = {}) {
  return useMutation({
    ...options,
    mutationFn: (vars = {}) => {
      const url = http.url("auth.signing.signIn");
      const body = vars.partner ? { partner: vars.partner } : {};
      return http.api.post(url, body);
    },
    onSuccess: (response) => {
      if (response?.data?.status === "success") {
        const { url } = response.data.data;
        if (url) {
          try {
            const parsed = new URL(url);
            if (parsed.protocol === "https:" || parsed.protocol === "http:") {
              window.location.href = url;
            }
          } catch {
            // Invalid URL, ignore redirect
          }
        }
      }

      if (typeof options.onSuccess === "function") {
        return options.onSuccess(response);
      }
    },
  });
}

export function useHandleSignInCallback({ options = {} } = {}) {
  const { setAccessToken, setUser } = useUser();

  return useMutation({
    ...options,
    mutationFn: ({ data }) => {
      const url = http.url("auth.nid.handle.callback");
      return http.api.post(url, { data: data });
    },
    onSuccess: (response) => {
      if (response?.data?.status === "success") {
        document.body.style.overflow = "auto";

        const {
          user,
          access_token: accessToken,
        } = response.data.data;

        if (accessToken) {
          setAccessToken(accessToken);
        }

        if (user) {
          setUser(user);
        }
      }

      if (typeof options.onSuccess === "function") {
        return options.onSuccess(response);
      }
    },
  });
}

export function useSignOut({ options = {} } = {}) {
  const { setAccessToken, setUser } = useUser();

  return useMutation({
    ...options,
    mutationFn: () => {
      const url = http.url("auth.signing.signOut");
      return http.api.post(url);
    },
    onSuccess: (response) => {
      if (response?.data?.status === "success") {
        setAccessToken(null);
        setUser(null);
        // Clear session-scoped UI state that's tied to "this logged-in user".
        sessionStorage.removeItem(SESSION_KEY_NOTIFICATIONS_BANNER_DISMISSED);
      }

      if (typeof options.onSuccess === "function") {
        return options.onSuccess(response);
      }
    },
  });
}
